export interface DossierAbandonFitterSuccess {
  type: 'success';
  comment: string;
}

export interface DossierAbandonFitterCancel {
  type: 'cancel';
}

export type DossierAbandonFitterOutputData =
  | DossierAbandonFitterSuccess
  | DossierAbandonFitterCancel;
